import api from '@/services/api'


const store = {
	namespaced: true,
	state: {
		config: {},
		familles: {},
		registertoken:null
	},
	mutations: {
		setconfig: (state, config) => {
			state.config = config;
		},
		setfamilles: (state, familles) => {
			state.familles = familles;
		},
		SETTOKEN: (state, token) => {
			state.registertoken = token;
		}
	},
	
	actions: {

		// supprime le token en place
		resetRegisterToken(context) {
			context.commit('SETTOKEN', null);
		},
		async pushregistration(context, token) {
			try {
				let call = await api.post({
					url: 'intervention/pushregistration',
					params: {userid: context.state.config.user.uid, registrationid: token}
				})
				context.commit('SETTOKEN', token);
			} catch (err) {
				console.log('error pushregistration', err);
			}
		},
		
		async refresh({commit, state}) {
			try {
				let call = await api.get({url: 'intervention/config'})
				commit('setconfig', call.response)
				console.log('setconfig', call.response)
				
			} catch (err) {
				console.log('config refresh', err);
			}
			try {
				let call = await api.get({url: 'intervention/v3/familles'})
				commit('setfamilles', call.response)
				console.log('setfamilles', call.response)
				
			} catch (err) {
				console.log('familles refresh', err);
			}
		}
		
		
	},
	getters: {
		getConfig: function (state) {
			return state.config;
		},
		getFamilles: function (state) {
			return state.familles;
		},
		getRegisterToken: function(state) {
			return state.registertoken;
		}
	},
	modules: {}
}

export default store